const NewsFilter = ($, context) => {

  const $links = $(".subsection-nav--filter li a", context)
  const $posts = $(".post-grid .post", context)

  const applyFilter = (e) => {
    e.preventDefault()
    const filter = e.currentTarget.getAttribute('href').substring(1)
    if(filter === 'all') {
      $posts.show(0);
    }
    else {
      $posts.filter('[data-filter="' + filter + '"]').show(0)
      $posts.filter(':not([data-filter="' + filter + '"])').hide(0)
    }
    $links.removeClass('active')
    $(e.currentTarget).addClass('active')
  }

  var self = {
    init: () => {
      $links.on('click', applyFilter)
    }
  }

  return self;
}

export default NewsFilter